import { render, staticRenderFns } from "./depart_structure.vue?vue&type=template&id=fd710792&scoped=true&"
import script from "./depart_structure.vue?vue&type=script&lang=js&"
export * from "./depart_structure.vue?vue&type=script&lang=js&"
import style0 from "./depart_structure.vue?vue&type=style&index=0&id=fd710792&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd710792",
  null
  
)

export default component.exports